import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private token: string | null = null;

  constructor() {

    window.addEventListener('message', (event) => {
      const allowedOrigins = [
        'https://dashboard-uat.cimbaligroup.tech',
        'https://dashboard.cimbaligroup.tech',
        'http://localhost:4200'
      ];
      console.log('Received event from ', event.origin);
      if (!allowedOrigins.includes(event.origin)) return;
      if (event.data.type === 'AUTH_DATA') {
        console.log('Setting token from event data');
        const { token } = event.data;
        this.token = token;
      }
    });
  }

  getToken(): string | null {
    return this.token;
  }
}
